import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-site-config-qr-page',
  templateUrl: './site-config-qr-page.component.html',
  styleUrls: ['./site-config-qr-page.component.scss']
})
export class SiteConfigQrPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
